module.exports = {
          srcSet: __webpack_public_path__ + "a508e56e23eeccd66d9e2d09cb62aed5-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "a508e56e23eeccd66d9e2d09cb62aed5-1920.png",width: 1920,height: 50}],
          src: __webpack_public_path__ + "a508e56e23eeccd66d9e2d09cb62aed5-1920.png",
          toString:function(){return __webpack_public_path__ + "a508e56e23eeccd66d9e2d09cb62aed5-1920.png"},
          
          width: 1920,
          height: 50
        }